export const c_menu_m_drilldown__list_Transition = {
  "name": "--pf-c-menu--m-drilldown__list--Transition",
  "value": "transform 250ms",
  "var": "var(--pf-c-menu--m-drilldown__list--Transition)"
};
export default c_menu_m_drilldown__list_Transition;